import { CSAT_RATINGS } from 'shared/constants/messages';

export const buildFilterList = (items, type) =>
  items.map(item => ({
    id: item.id,
    name: type === 'ratings' ? item.emoji : item.name,
    type,
  }));

export const buildRatingsList = t =>
  CSAT_RATINGS.map(rating => ({
    id: rating.value,
    name: `${t(rating.translationKey)}`,
    type: 'ratings',
  }));

export const SURVEY_TYPES = ['default', 'satisfaction', 'audience'];

export const buildSurveyTypesList = t =>
  SURVEY_TYPES.map(surveyType => ({
    id: surveyType,
    name: t(
      `CSAT_REPORTS.FILTERS.SURVEY_TYPES.OPTIONS.${surveyType.toUpperCase()}`
    ),
    type: 'survey_types',
  }));

export const getActiveFilter = (filters, type, key) =>
  filters.find(item => item.id.toString() === key.toString());

export const getFilterType = (input, direction) => {
  const filterMap = {
    keyToType: {
      user_ids: 'agents',
      inbox_id: 'inboxes',
      team_id: 'teams',
      rating: 'ratings',
      survey_type: 'survey_types',
    },
    typeToKey: {
      agents: 'user_ids',
      inboxes: 'inbox_id',
      teams: 'team_id',
      ratings: 'rating',
      survey_types: 'survey_type',
    },
  };
  return filterMap[direction][input];
};
